export default "__VITE_ASSET__9d8345b0__"